import Class from '@core/Class';
import Module from '@core/Module';
import * as HtmlComponents from '@util/HtmlComponents';
import contains from 'ramda/src/contains';

const Contenteditable = (Class.extend( Module )).extend( {

    _data: '',
    _previousData: '',
    _setData: function ( val, ignorePrevious ) {
        if ( !ignorePrevious ) {
            this._previousData = this._data;
        }
        this._data = val;
    },
    _getData: function () {
        return this._data;
    },

    init: function ( el ) {
        this.$el = $( el );
        this.fieldName = this.$el.attr( 'data-name' );
        // set initial value state
        this._setData( this.getContents() );

        this.$el.on( 'keydown', this.handleKeydown.bind( this ) );
        this.$el.on( 'keyup', this.change.bind( this ) );
        this.$el.on( 'blur', this.save.bind( this ) );
    },

    handleKeydown: function ( e ) {
        const esc = e.which === 27,
            nl = contains( e.which, [13, 9] );

        if ( esc ) {
            // restore state
            document.execCommand( 'undo' );
            this.change();
            this.$el.blur();
            return;
        }
        else if ( nl ) {
            e.preventDefault();
            this.$el.blur();
            return false;
        }
    },

    getContents: function () {
        return this.$el.text().toString().trim().replace( /\r|\n/, '' );
    },

    setContents: function ( val, ignorePrevious ) {
        // note -> [contenteditable] is seeded with <br/> (if empty) to fix cursor placement bug in firefox
        // issue reference:
        // https://stackoverflow.com/questions/21986985/firefox-sets-wrong-caret-position-contenteditable-on-focus
        // https://bugzilla.mozilla.org/show_bug.cgi?id=904846
        this.$el.html( val || '<br/>' );
        this._setData( val, ignorePrevious );
    },

    resetField: function ( val ) {
        this.$el.removeClass( 'is-saved' );
        this.setContents( this._previousData, true );
        this.change();
    },

    hasValue: function () {
        const content = this.getContents();
        return !!(content && content.length > 0);
    },

    change: function () {
        this.send( 'contenteditable:changed' );
    },

    save: function () {
        const contents = this.getContents();

        // only save if value has changed
        if ( contents !== this._getData() ) {
            this.setContents( contents );
            this.send( 'contenteditable:saved' );
            this.$el.addClass( 'is-saved' );
        }
    },

    send: function ( type ) {
        this.$el.trigger( type, {
            contenteditable: this,
            el: this.$el,
            contents: this.getContents()
        } );
    }
} );

export default {
    create: function () {
        return new Contenteditable( HtmlComponents.contenteditable() );
    }
};

